import React from "react";
import "./GlobalFooter.css";

function GlobalFooter() {
  return (
    <div className="global-footer-global-footer" style={{}}>
      <div className="global-footer-container">
        <div className="global-footer-branding">
          <div className="global-footer-logo">
            <div className="global-footer-logo2">
              {/* Replaced old SVGs with the new combined SVG */}
              <svg
                id="Logo"
                xmlns="http://www.w3.org/2000/svg"
                // The viewBox is intrinsic to the new SVG's internal coordinate system.
                viewBox="0 0 3026.628 1065.9744"
                // Set width and height to fill the parent container defined by CSS.
                // The CSS will handle the specific dimensions for .global-footer-logo2
                width="100%"
                height="100%"
                fill="none" // Fill is handled by paths and styles within the SVG
              >
                <defs>
                  <style>
                    {`
                      /* Define the CSS class for the Eye_Mark fill */
                      .cls-1 {
                        fill: #76b900; /* Green color for the eye mark */
                      }
                    `}
                  </style>
                </defs>
                <g id="NVIDIA_Logo" data-name="NVIDIA Logo">
                  <path
                    id="Eye_Mark"
                    data-name="Eye Mark"
                    className="cls-1" // Applies the green fill
                    d="M562.33277,440.32747v-41.51484c4.03067-.28719,8.1015-.50201,12.24981-.63193,113.54578-3.56881,188.03666,97.56221,188.03666,97.56221,0,0-80.45467,111.74769-166.71866,111.74769-12.42474,0-23.54317-2.00293-33.56781-5.3669v-125.88817c44.20443,5.33954,53.09028,24.86431,79.67288,69.16142l59.10445-49.83382s-43.14312-56.58671-115.8735-56.58671c-7.9143,0-15.4767.5593-22.90382,1.35106M562.33277,303.1884v62.01116c4.07568-.32223,8.15648-.5818,12.24981-.72911,157.90263-5.31959,260.7719,129.49688,260.7719,129.49688,0,0-118.16107,143.68237-241.25685,143.68237-11.27852,0-21.84021-1.04136-31.76486-2.79725v38.33066c8.48868,1.07896,17.27709,1.71318,26.45269,1.71318,114.55722,0,197.39715-58.49733,277.61961-127.73864,13.29143,10.64905,67.74555,36.55502,78.94403,47.91078-76.27925,63.8494-254.03143,115.31395-354.80289,115.31395-9.71009,0-19.05038-.58692-28.21344-1.46589v53.86951h435.40256v-459.5976h-435.40256ZM562.33277,602.12371v32.72874c-105.95116-18.89054-135.35863-129.02735-135.35863-129.02735,0,0,50.87022-56.36448,135.35863-65.49762v35.90806c-.06496,0-.10741-.01739-.16495-.01739-44.33435-5.3247-78.97625,36.10037-78.97625,36.10037,0,0,19.40738,69.7357,79.1412,89.80519M374.15111,501.05253s62.7955-92.65973,188.18166-102.2399v-33.61307c-138.87732,11.14605-259.14388,128.76777-259.14388,128.76777,0,0,68.11253,196.9202,259.14388,214.94916v-35.73339c-140.18363-17.63692-188.18166-172.13057-188.18166-172.13057Z"
                  />
                  <path
                    id="NVIDIA"
                    d="M1782.01265,390.03445l.03032,301.67443h85.19616v-301.66925l-85.22648-.00518ZM1111.78798,389.62451v302.08437h85.95644v-229.37664l66.58895.0228c22.0588,0,37.76845,5.48885,48.39789,16.83063,13.47648,14.36088,18.97673,37.51036,18.97673,79.87678v132.64642l83.26888-.01517.01517-166.88462c0-119.12071-75.93155-135.18458-150.2135-135.18458h-152.99057M1919.19381,390.04455v301.66433h138.18813c73.62635,0,97.65634-12.24536,123.64508-39.69921,18.37193-19.27266,30.23999-61.58103,30.23999-107.81676,0-42.40166-10.04613-80.23101-27.57538-103.78783-31.56337-42.12595-77.03751-50.36052-144.92443-50.36052h-119.5734ZM2003.70639,455.73018h36.63217c53.14408,0,87.51406,23.86545,87.51406,85.78801,0,61.93785-34.36998,85.8033-87.51406,85.8033h-36.63217v-171.59131ZM1659.17216,390.04455l-71.10451,239.08643-68.13387-239.07114-91.97003-.01529,97.30444,301.66433h122.79488l98.06887-301.66433h-86.95979ZM2250.91311,691.70888h85.21119v-301.64904l-85.2314-.01529.02021,301.66433ZM2489.75155,390.15339l-118.96885,301.45158h84.00935l18.82205-53.28064h140.7947l17.81765,53.28064h91.21103l-119.8771-301.47672-113.80883.02514ZM2545.0565,445.14997l51.61056,141.22486h-104.85077l53.24021-141.22486Z"
                    fill="black" // Explicitly setting fill for the wordmark
                  />
                </g>
              </svg>
            </div>
          </div>
          <div className="global-footer-country">United States </div>
        </div>
        <div className="global-footer-container2" style={{marginLeft:"16px"}}>
          <div className="global-footer-links">
            <div className="global-footer-item">
              <a
                className="global-footer-privacy-policy"
                href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy{" "}
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-manage-my-privacy"
                href="https://www.nvidia.com/en-us/privacy-center/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Manage My Privacy
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-manage-my-privacy"
                href="https://www.nvidia.com/en-us/preferences/email-preferences/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Do Not Sell or Share My Data
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-manage-my-privacy"
                href="https://www.nvidia.com/en-us/about-nvidia/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-legal"
                href="https://www.nvidia.com/en-us/about-nvidia/accessibility/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Accessibility
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-accessibility"
                href=" https://www.nvidia.com/en-us/about-nvidia/company-policies/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Corporate Policies
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-product-security"
                href="https://www.nvidia.com/en-us/product-security/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Product Security
              </a>
              <span className="equal-space">|</span>
              <a
                className="global-footer-contact"
                href="https://www.nvidia.com/en-us/contact/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact
              </a>
            </div>
          </div>
          <div className="copyright-2022-nvidia-corporation">
            Copyright © {new Date().getFullYear()} NVIDIA Corporation
          </div>
        </div>
      </div>
    </div>
  );
}

export default GlobalFooter;